<script lang="ts">
  import { onMount } from "svelte";
  import type { Props } from "./IconV1.types.ts";

  let { type }: Pick<Props, "type"> = $props();

  onMount(() => {
    /*                                                                            */
    /*                                                                                        */
    if (type === "wishlist") import("./animatedSVG/animatedWishlistActiveHighlight.svg?raw");
  });
</script>

{#if type === "animated-wishlist-active-highlight"}
  {#await import("./animatedSVG/animatedWishlistActiveHighlight.svg?raw") then { default: svg }}
    <!-- eslint-disable svelte/no-at-html-tags -->
    {@html svg}
  {/await}
{/if}
